import { useTranslation } from 'react-i18next';
import { useSessionStore } from '../state/session-store.js';

/** Shown over the world while a dropped connection is being resumed. */
export function ReconnectBanner() {
  const { t } = useTranslation();
  const status = useSessionStore((s) => s.status);
  if (status !== 'reconnecting') return null;
  return (
    <div className="announcement reconnecting" role="status">
      {t('connection.reconnecting')}
    </div>
  );
}
